(ns app.front.view.group.admin.import.inspection
  (:require [app.domain.inspection.model :as inspection-model]
            [app.front.view.group.admin.import.common :as import-session-common]
            [app.front.view.group.admin.inspections.subs :as ias]
            [app.front.view.group.admin.inspections.template-editor :as inspection-template-editor]
            [core.db.entity.util :as eu]
            [core.front.event :refer [<sub]]
            [core.front.href :as href]
            [core.user.model :as user-model]
            [re-frame.core-instrumented :as rf]))

(rf/reg-sub ::inspection-types
  :<- [::inspection-template-editor/template-entities]
  (fn [inspection-types _]
    (->> inspection-types
         (sort-by (juxt (comp :ordered/order :entity/parent)
                        :db/id)))))


(def inspector-settings
  (import-session-common/string-to-value-mapping-settings :inspection.visit/inspectors
                                                          ::import-session-common/users
                                                          :db/id
                                                          (fn [user _] (user-model/full-name user))))


(defmethod import-session-common/mapping-settings :inspection.visit/inspectors
  [props]
  [inspector-settings props])

(rf/reg-sub ::priorities
  (fn [_ _]
    inspection-model/inspection-priorities))

(def inspection-priority-settings
  (import-session-common/string-to-value-mapping-settings :inspection/priority
                                                          ::priorities
                                                          identity
                                                          (fn [result _] result)))

(defmethod import-session-common/mapping-settings :inspection/priority
  [props]
  [inspection-priority-settings props])


(def inspection-type-settings
  (import-session-common/string-to-value-mapping-settings :data-import.mapping/inspection-type
                                                          ::inspection-types
                                                          :db/id
                                                          (fn [inspection-template lang]
                                                            (-> inspection-template
                                                                :entity/parent
                                                                (inspection-model/inspection-template-kind-name lang)))))


(defmethod import-session-common/mapping-settings :data-import.mapping/inspection-type
  [props]
  [inspection-type-settings props])


(rf/reg-sub ::results
  (fn [_ _]
    (cons :data-import/no-visit ;; just import as booking
          inspection-model/visit-results)))

(def inspection-result-settings
  (import-session-common/string-to-value-mapping-settings :inspection.visit/result
                                                          ::results
                                                          identity
                                                          (fn [result _] result)))

(defmethod import-session-common/mapping-settings :inspection.visit/result
  [props]
  [inspection-result-settings props])


(rf/reg-sub ::visit-results
  :<- [::ias/visit-result-entities]
  (fn [results]
    (cons :data-import/no-visit ;; just import as booking
          results)))


(def inspection-visit-result-settings
  (import-session-common/string-to-value-mapping-settings :inspection.visit/visit-result
                                                          ::visit-results
                                                          #(or (:db/id %) %)
                                                          (fn [result lang]
                                                            (or (inspection-model/visit-result-name result lang)
                                                                result))))


(defmethod import-session-common/mapping-settings :inspection.visit/visit-result [props]
  [inspection-visit-result-settings props])


(defmethod import-session-common/entities-cols :import-session.type/inspection [_]
  (let [tr           (<sub [:tr])
        lang         (<sub [:language])
        visits-conf? (<sub [::ias/visit-configuration-enabled?])]
    [[:entity/type
      (comp tr vector :entity/type)]
     [:workspace/municipal-case-id
      (comp :workspace/municipal-case-id :entity/parent :entity/parent :entity/parent)
      {}]
     [:inspection/name
      (comp #(inspection-model/inspection-name % lang) :entity/parent)
      {}]
     [:inspection.visit/result
      (if visits-conf?
        (fn [{:keys [:inspection.visit/visit-result]}]
          (when visit-result (inspection-model/visit-result-name visit-result lang)))
        (fn [{:keys [:inspection.visit/result]}]
          (when result (tr [result]))))
      {}]]))

(defmethod import-session-common/entity-href :import-session.type/inspection [_ inspection-or-visit-or-booking]
  (let [inspection (if (eu/is-type? :entity.type/inspection inspection-or-visit-or-booking)
                     inspection-or-visit-or-booking
                     (-> inspection-or-visit-or-booking :entity/parent))]
    (href/href :view/inspection-visit {:workspace-id  (-> inspection
                                                          inspection-model/workspace
                                                          :workspace/id)
                                       :inspection-id (:db/id inspection)})))
